import { Link } from 'react-router-dom';
import { FirebaseBrain } from '../services/FirebaseBrain/FirebaseBrain';

const TableElementCell = ({ number, symbol, property, classNames, radioactive, source }) => {

  const handleClick = () => {
    // источник задаёт экран-вызыватель (см. PeriodicTable). Без source не логируем,
    // чтобы не словить событие с пустым read_element_from при переиспользовании ячейки.
    if (source) FirebaseBrain.getReadElement(source, number - 1); // number-1 = 0-based индекс, как на Android
  };

  return (
    <td className={classNames}>
      <Link to={`/element/${number}`} className='element__link' onClick={handleClick}>
        <span className='element__number'>{number}</span>
        {radioactive && <span className='radioactive' />}
        <span className='element__symbol'>{symbol}</span>
        <span className='element__name'>{property}</span>
      </Link>
    </td>
  );
};

export default TableElementCell;